var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 0L7 35L17.5 45.5L63 0H42Z",
    fill: "#40C4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63 31.5L43.75 50.75L33.25 40.25L42 31.5H63Z",
    fill: "#40C4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2495 40.2502L22.75 50.75L33.2498 61.2495L43.7493 50.7496L33.2495 40.2502Z",
    fill: "#03A9F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63 70H42L33.25 61.25L43.75 50.75L63 70Z",
    fill: "#01579B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 61.25L49 56L43.75 50.75L33.25 61.25Z",
    fill: "#084994"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.3e0cb4a1089cebd61e70840a76fefb2e.svg";
export { ForwardRef as ReactComponent };